import React from 'react';
import './NoteList.css'; // External CSS for styling
// Define the TypeScript type for the document structure
import { safeDateFormat } from 'utils/GeneralUtil';
interface Note {
  id: number;
  userId: number;
  note: string | null;
  createdAt: string;
  updatedAt: string;
  type?: string;
  image?: string;
}

// Props type for the component
interface NoteListProps {
  notes: Note[];
  heading?: string;
}

const NoteList: React.FC<NoteListProps> = ({
  notes,
  heading = 'Rejection Notes',
}) => {
  return notes.length ? (
    <div>
      <h4>{heading}</h4>
      <div className="grid-container">
        {notes.map((noteObj) => (
          <div key={noteObj.id} className="grid-item">
            <div>
              <h4 className="note-name">{noteObj.note}</h4>
              <p className="upload-date">
                Rejected On:{' '}
                {safeDateFormat(noteObj.createdAt)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default NoteList;
